// extracted by mini-css-extract-plugin
module.exports = {"term":"Definition-hashed__term__1npBn","definition":"Definition-hashed__definition__3feJc"};